import classNames from 'classnames';
import styles from './SetupIpaChannelsInfoCallout.module.scss';

type SetupIpaChannelsInfoCalloutProps = {
  isFarmaClient: boolean;
};

const NotFarmaComponent = () => (
  <p className="font-size-100-regular">No seu pacote contratado não é possível habilitar a criação de regras e edição de preço de oferta</p>
);

const FarmaComponent = () => (
  <>
    <h3 className="font-size-100-semibold">Importante</h3>
    <p className="font-size-100-regular">
      Ao habilitar a criação de regras e a edição do preço de oferta,{' '}
      <strong>é fundamental que a integração de saída com o seu sistema ERP seja configurada.</strong>
    </p>
    <p>
      Essa integração é responsável por enviar as atualizações de preços e regras do nosso sistema para o seu ERP, garantindo a sincronização das informações.
    </p>
  </>
);

export const SetupIpaChannelsInfoCallout = ({ isFarmaClient = false }: SetupIpaChannelsInfoCalloutProps) => {
  return (
    <div className={styles.wrapper}>
      {isFarmaClient ? <FarmaComponent /> : <NotFarmaComponent />}
      <a className={classNames(styles.button, 'link-button', 'link-button-small')} href="mailto:atendimento@infoprice.co">
        Entre em contato para mais informações
      </a>
    </div>
  );
};
